import moment from "moment";
import { useState, useMemo } from "react";
import { useQuery } from "react-query";

export default function useListQuery(apiService, apiKey, options = {}) {
  const {
    defaultPageSize = 10,
    defaultFilters = {},
    defaultSorter = {},
    defaultStartDate = null,
    defaultEndDate = null,
    enabled = true,
  } = options;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: defaultPageSize,
  });
  const [filters, setFilters] = useState(defaultFilters);
  const [sorter, setSorter] = useState(defaultSorter);
  const [searchValue, setSearchValue] = useState("");
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [hasMore, setHasMore] = useState(false);

  const {
    data: res,
    refetch,
    isFetching: loading,
  } = useQuery({
    queryKey: [
      apiKey,
      filters,
      sorter,
      pagination,
      searchValue,
      startDate,
      endDate,
    ],
    queryFn: () =>
      apiService({
        skip:
          ((pagination?.current || pagination.current) - 1) *
          (pagination?.pageSize || pagination.pageSize),
        limit: pagination?.pageSize || pagination.pageSize,
        filter: {
          ...filters,
        },
        order: {
          ...sorter,
        },
        ...(searchValue && {
          searchText: searchValue,
        }),
        ...(startDate && {
          startDate: moment(startDate).set("HH", 0).set("mm", 0).set("ss", 0),
        }),
        ...(endDate && {
          endDate: moment(endDate).set("HH", 23).set("mm", 59).set("ss", 59),
        }),
      }),
    enabled,
    onSuccess: (data) => {
      if (data?.total > 0) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    },
  });

  const data = useMemo(() => {
    return res?.data || [];
  }, [res]);

  // Thay đổi từ Table
  const handleTableChange = (newPagination, newFilters, newSorter, dates) => {
    if (dates !== undefined) {
      setPagination({ ...newPagination, current: 1 });
      setStartDate(dates && dates.length > 0 ? dates[0] : null);
      setEndDate(dates && dates.length > 0 ? dates[1] : null);
    } else {
      setPagination(newPagination);
    }
    setFilters(newFilters);
    setSorter(newSorter);
  };

  // Thay đổi filter/sort từ modal custom (nếu có)
  const applyFilterAndSort = (newFilters = filters, newSorter = sorter) => {
    setPagination((p) => ({ ...p, current: 1 })); // reset về trang 1
    setFilters(newFilters);
    setSorter(newSorter);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    setPagination((p) => ({ ...p, current: 1 })); // reset về trang 1
  };

  return {
    data,
    loading,
    pagination,
    filters,
    sorter,
    hasMore,
    startDate,
    endDate,
    searchValue,
    handleTableChange,
    applyFilterAndSort,
    setPagination, // nếu muốn chỉnh thủ công
    setFilters,
    setSorter,
    refetch,
    handleSearch,
  };
}
